import { Add, FileDownload, FileUpload } from "@mui/icons-material"
import { Button, Grid } from "@mui/material"

type TopActionsBarProps = {
  onAddTagRowClick: () => void
  onImportClick: (e: React.ChangeEvent<HTMLInputElement>) => void
  onExportClick: () => void
}

const TopActionsBar = (props: TopActionsBarProps) => {
  return (
    <Grid container wrap="nowrap" justifyContent="space-between">
      <Grid item>
        <Button
          startIcon={<Add fontSize="small" />}
          variant="contained"
          onClick={props.onAddTagRowClick}
        >
          Add tag row
        </Button>
      </Grid>

      <Grid container item xs="auto" gap={1}>
        <Grid item>
          <Button
            startIcon={<FileUpload fontSize="small" />}
            variant="contained"
            component="label"
            sx={{ borderRadius: 0 }}
          >
            <input type="file" accept="text/csv" hidden value="" onChange={props.onImportClick} />
            Import
          </Button>
        </Grid>
        <Grid item>
          <Button
            startIcon={<FileDownload fontSize="small" />}
            variant="contained"
            onClick={props.onExportClick}
          >
            Export
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TopActionsBar
